/**
 * 🏢 Credit لشركة رامة الذكية (المطوّر)
 *    موجود في كل الصفحات
 *    dir="rtl" مفروض حتى لما الصفحة LTR (اللغة الإنجليزية) عشان النص العربي يطلع صح
 */
export function RamhCredit({ inverted = false, className = '' }: { inverted?: boolean; className?: string }) {
  return (
    <a
      href="https://ramh.sa"
      target="_blank"
      rel="noreferrer"
      dir="rtl"
      className={`inline-flex flex-col items-center gap-0 text-[10px] leading-tight transition hover:opacity-100 ${
        inverted ? 'text-white/50 hover:text-white/80' : 'text-gray-500 hover:text-navy-dark'
      } ${className}`}
      title="تصميم وتطوير شركة رامة الذكية — ALI FAHAD"
    >
      <span className="opacity-80">تصميم وتطوير</span>
      <span className="font-bold whitespace-nowrap">
        شركة رامة الذكية
        <span className="opacity-60 mx-1">·</span>
        <span dir="ltr">ALI FAHAD</span>
      </span>
    </a>
  );
}
